import { Link } from "react-router-dom";
import { Button, Icon, Divider } from "antd";
import illustration from "Images/undraw_towing.svg";
import styled from 'styled-components'

const ErrorPageContainer = styled.div`
  background: var(--background);
  color: var(--primaryColor);
  width: 100%;
  height: 100%;
  margin-top: 40px;
  text-align: center;

  & > .ant-divider {
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 20%;
    width: 60%;
    min-width: 20%;
    height: 1px;
  }

  & > * {
    width: 50%;
    margin: 0 25%;
    text-align: left;
  }
  & > img {
    max-width: 400px;
    margin: 40px;
  }
  & > h2 {
    margin-bottom: 10px;
    font-size: 30pt;
  }
  & > p {
    margin: 20px 25%;
    line-height: 1.6rem;
    text-align: center;
  }
  & > h1 {
    &:first-child {
      margin-top: 50px;
    }
    font-weight: 600;
  }
  & > *:last-child {
    margin-top: 20px;
  }
`;
class Error extends React.Component {

  constructor(props) {
    super(props)
    this.clearLocalStorage = this.clearLocalStorage.bind(this)
  }

  clearLocalStorage() {
    localStorage.clear()
    this.refresh()
  }

  refresh() {
    location.reload()
  }

  render() {
    const { error, info } = this.props
    return (
      <ErrorPageContainer>
        <img src={illustration} size="large"/>
        <h2 style={{ textAlign: 'center' }}>500</h2>
        <Divider />
        <p>
          We apologize, an error occured on our end. We have been notified.
          Try refreshing the page by clicking the button below, or go back and attempt the action again.
        </p>
        <div style={{textAlign: 'center'}}>
          <Button
            type="primary"
            size="large"
            onClick={this.refresh}>
              Click here to refresh
          </Button>
        </div>
        <p>
          If the issue persists, try clicking <Button danger onClick={this.clearLocalStorage}>here</Button> to clear local user data. <b>This will remove all locally stored settings.</b>
        </p>
      </ErrorPageContainer>
    )
  }

}

export default Error;
